import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

interface MenuItem {
  id: string;
  label: string;
  icon: LucideIcon;
  route: string;
  description?: string;
}

interface MobileMenuPageProps {
  title?: string;
  description?: string;
  menuItems: MenuItem[];
  className?: string;
}

const MobileMenuPage: React.FC<MobileMenuPageProps> = ({
  title,
  description,
  menuItems,
  className = ''
}) => {
  const navigate = useNavigate();

  const handleMenuItemClick = (route: string) => {
    navigate(route);
  };

  return (
    <div className={`lg:hidden ${className}`}>
      {/* Header - Only show if title provided */}
      {title && (
        <div className="mb-4">
          <h1 className="text-2xl font-bold text-text-primary dark:text-text-dark-primary mb-2">
            {title}
          </h1>
          {description && (
            <p className="text-text-secondary dark:text-text-dark-secondary">
              {description}
            </p>
          )}
        </div>
      )}

      {/* Menu Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => handleMenuItemClick(item.route)}
              className="card p-4 min-h-20 flex items-center gap-3 hover:shadow-lg transition-shadow text-left group"
            >
              <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center group-hover:bg-primary-200 dark:group-hover:bg-primary-900/50 transition-colors">
                <Icon className="w-6 h-6 text-primary-700 dark:text-primary-400" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-text-primary dark:text-text-dark-primary mb-1">
                  {item.label}
                </h3>
                {item.description && (
                  <p className="text-xs text-text-secondary dark:text-text-dark-secondary line-clamp-2">
                    {item.description}
                  </p>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileMenuPage;
